
import { createClient } from '@supabase/supabase-js';

// Environment variables from Vercel/Vite
const envUrl = ((import.meta as any).env && (import.meta as any).env.VITE_SUPABASE_URL);
const envKey = ((import.meta as any).env && (import.meta as any).env.VITE_SUPABASE_ANON_KEY);

// Hardcoded fallbacks for Preview (User Provided)
const fallbackUrl = 'https://roplktouzhoawzqqcgyh.supabase.co';
// Note: This looks like a custom token format provided by the user, different from standard JWTs.
const fallbackKey = 'sb_publishable_YmxTW77rrBzJyK9P0AZNAw_g_N6AYCS';

const supabaseUrl = envUrl || fallbackUrl;
const supabaseAnonKey = envKey || fallbackKey;

if (!supabaseUrl || !supabaseAnonKey) {
  console.error("CRITICAL: Supabase credentials missing. Check Vercel Environment Variables or Fallback constants.");
}

export const supabase = createClient(
  supabaseUrl || '',
  supabaseAnonKey || ''
);
